import { TextField, TextFieldProps } from "@mui/material";

export type CreateTextFieldProps = TextFieldProps & {
	value?: string;
	onCreate: (value: string) => void;
};

const CreateTextField: React.FC<CreateTextFieldProps> = (
	props: CreateTextFieldProps
) => {
	function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>): void {
		if (e.key === "Enter") {
			e.preventDefault();
			const element = e.target as HTMLInputElement;
			props.onCreate(element.value.trim());
		}
	}

	function handleBlur(e: React.FocusEvent<HTMLInputElement>): void {
		props.onCreate(e.target.value.trim());
	}

	return (
		<TextField
			autoFocus={props.autoFocus}
			defaultValue={props.value}
			disabled={props.disabled}
			error={props.error}
			fullWidth={props.fullWidth}
			variant={props.variant}
			onKeyDown={handleKeyDown}
			onBlur={handleBlur}
		/>
	);
};

export default CreateTextField;
